import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getCpfTypes = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetCPFTypes}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useCpfTypesQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCPFTypes],
    queryFn: () => getCpfTypes(companyCode),
     refetchOnWindowFocus: false,
    
  });
};
